<template>
    <div class="searchParkinglot">
        <div style="position: relative">
            <van-search @clear="clear" @input="onSearch" id="tipinput" v-model="keyword" placeholder="搜索">
                <!-- <template #action>
                <van-button class="searchBtn" @click="onSearch(keyword)">搜索</van-button>
            </template> -->
            </van-search>
            <div v-if="addressList.length > 0" class="address-list-dropdown">
                <template v-if="addressList.length > 0">
                    <div class="address-list-dropdown-item" @click="choseAddress(item)" v-for="item in addressList"
                        :key="item.id">
                        {{ item.name }} <span class="address">({{ item.address }})</span>
                    </div>
                </template>
                <template v-if="addressList.length == 0">
                    <div class="address-list-dropdown-item">暂无数据</div>
                </template>
            </div>
        </div>

        <div v-if="parkingLotList.length == 0" class="searchParkinglot-content">
            <!-- 车场推荐 -->
            <div class="searchParkinglot-wrap">
                <p class="parkinglot-name">车场推荐</p>
                <div class="searchParkinglog-list flex align-center wrap">
                    <div class="searchParkinglog-item" @click="toParking(item)"
                        v-for="(item, index) in parkingRecommend" :key="index">
                        <span>{{ item.parkName }}</span>
                    </div>
                </div>
            </div>
            <!-- 地点推荐 -->
            <div class="searchParkinglot-wrap">
                <p class="parkinglot-name">地点推荐</p>
                <div class="searchParkinglog-list flex align-center wrap">
                    <div class="searchParkinglog-item" @click="toAddress(item)" v-for="(item, index) in siteRecommend"
                        :key="index">
                        <span>{{ item.address }}</span>
                    </div>
                </div>
            </div>
            <!-- 搜索历史 -->
            <div v-if="searchHistory.length > 0" class="searchParkinglot-wrap">
                <div class="parkinglot-name flex align-center">
                    <span>历史搜索</span>
                    <span @click="deleteHistory"><img src="@/assets/images/del.png" alt="" /></span>
                </div>
                <div class="searchParkinglog-list flex align-center wrap">
                    <div class="searchParkinglog-item" @click="useHistory(item)" v-for="(item, index) in searchHistory"
                        :key="index">
                        <span>{{ item }}</span>
                    </div>
                </div>
            </div>
        </div>

        <parking-list v-if="parkingLotList.length > 0" :parkingLotList="parkingLotList" />
    </div>
</template>

<script>
import { debounce } from "@/libs/tools";
import ParkingList from "@/components/parking/parking-list.vue";
import { getSearchRecommendList, listHotPlaces } from "@/api/api";
// import AMapLoader from "@amap/amap-jsapi-loader";
import config from "@/config/index";
export default {
    name: "SearchParkinglot",
    components: {
        ParkingList,
    },
    data() {
        return {
            keyword: "",
            parkingRecommend: [],
            siteRecommend: [
                { address: "锦绣公园", lng: "118.916224", lat: "25.115317" },
                { address: "南山中路", lng: "118.913335", lat: "25.126176" },
                { address: "泉港一中", lng: "118.925664", lat: "25.121552" },
                { address: "中兴街", lng: "118.917961", lat: "25.126023" },
            ], // 推荐地点

            searchHistory: [],
            parkingLotList: [],

            autoOptions: {
                city: "泉港",
            },
            placeSearch: {}, // 高德地图搜索对象
            addressList: [], // 搜索出的地点
        };
    },
    watch: {
        keyword(newValue, oldValue) {
            if (!newValue) {
                this.parkingLotList = [];
            }
        },
    },
    mounted() {
        this.getAmapAddress();
        this.getSearchHistory();
        this.getRecommendList();
        this.getlistHotPlaces();
    },
    methods: {
        // 高德地图地点推荐
        // getAmapAddress() {
        //     if (this.$Amap) {
        //         //输入提示

        //         this.placeSearch = new AMap.PlaceSearch(this.autoOptions);

        //         clearInterval(this.timer);
        //     } else {
        //         this.timer = setInterval(this.getAmapAddress, 1000);
        //     }
        // },

        getAmapAddress() {
            let that = this;
            // AMapLoader.load({
            //     key: config.AMAP_KEY, // key
            //     plugins: ["AMap.PlaceSearch"], // 插件
            // })
            //     .then((Amap, b) => {
            //         that.placeSearch = new Amap.PlaceSearch(that.autoOptions);
            //     })
            //     .catch((err) => {
            //         throw new Error("加载高德地图失败：" + err);
            //     });
        },

        // 获取推荐车场
        getRecommendList() {
            let obj = {
                radiusStart: "2.0",
                radiusEnd: "3.0",
            };
            if (this.$route.params.lng == undefined) {
                obj = {
                    ...obj,
                    ...this.$store.state.location.location,
                };
            } else {
                obj = {
                    ...obj,
                    ...this.$route.params,
                };
            }

            getSearchRecommendList(obj).then((res) => {
                this.parkingRecommend = res.data;
            });
        },
        // 获取推荐地点
        getlistHotPlaces() {
            listHotPlaces().then((res) => {
                this.siteRecommend = res.data;
            });
        },
        // 获取搜索历史
        getSearchHistory() {
            if (localStorage.getItem("searchHistory")) {
                this.searchHistory = JSON.parse(localStorage.getItem("searchHistory"));
            } else {
                this.searchHistory = [];
            }
        },
        // 跳转到车场
        toParking(item) {
            item.type = "parking";
            this.$router.push({ name: "Parking", params: item });
        },
        // 跳转到地点
        toAddress(item) {
            item.type = "address";
            this.$router.push({ name: "Parking", params: item });
        },
        // 删除历史搜索数据
        deleteHistory() {
            localStorage.removeItem("searchHistory");
            this.searchHistory = [];
        },
        // 设置搜索历史
        setSearchHistory() {
            // 如果searchHistory存在
            if (localStorage.getItem("searchHistory")) {
                let historyList = JSON.parse(localStorage.getItem("searchHistory"));
                let index = historyList.indexOf(this.keyword);
                // 搜索项存在,将存在的拿到头部
                if (index != -1) {
                    historyList.splice(index, 1);
                    historyList.unshift(this.keyword);
                    this.searchHistory = historyList;
                    localStorage.setItem("searchHistory", JSON.stringify(historyList));
                }
                // 搜索项不存在
                else {
                    historyList.unshift(this.keyword);
                    this.searchHistory = historyList;

                    localStorage.setItem("searchHistory", JSON.stringify(historyList));
                }
            }
            // 如果searchHistory不存在
            else {
                let historyList = [this.keyword];
                this.searchHistory = historyList;
                localStorage.setItem("searchHistory", JSON.stringify(historyList));
            }
        },
        // 选择地点
        choseAddress(item) {
            this.setSearchHistory();
            let obj = {
                lng: item.location.lng,
                lat: item.location.lat,
                type: "address",
            };
            this.$router.push({ name: "Parking", params: obj });
        },
        // 清空
        clear() {
            this.parkingLotList = [];
        },
        // 搜索
        onSearch: debounce(function (value) {
            let that = this;
            console.log(value);
            this.placeSearch.search(value, function (status, result) {
                console.log(result);

                if (result == "INVALID_PARAMS") {
                    that.addressList = [];
                    return;
                }

                that.addressList = result.poiList.pois;
            });
            // let obj = {
            //     parkName: value,
            // };

            // if (this.$route.params.lng == undefined) {
            //     obj = {
            //         ...obj,
            //         ...this.$store.state.location.location,
            //     };
            // } else {
            //     obj = {
            //         ...obj,
            //         ...this.$route.params,
            //     };
            // }

            // this.setSearchHistory();
            // //停车场搜索
            // getParkDistribute(obj).then((res) => {
            //     if (res.data.length == 0) {
            //         this.$toast("未搜索到停车场");
            //     }
            //     this.parkingLotList = res.rows;
            // });
        }, 300),

        useHistory(value) {
            this.keyword = value;
            this.onSearch(value);
        },
    },
};
</script>

<style lang="less" scoped>
.address-list-dropdown {
    background-color: #fff;
    overflow-y: auto;
    position: absolute;
    left: 80px;
    top: 90px;
    box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.2);
    z-index: 10;
    max-height: 800px;
    width: 630px;

    color: #000;

    .address-list-dropdown-item {
        height: 80px;
        width: 600px;
        margin: 0 auto;
        line-height: 80px;
        // display: flex;
        // align-items: center;
        // justify-content: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        border-bottom: 1px solid #dbdada33;

        .address {
            color: #a3a3a3;
        }
    }

    .address-list-dropdown-item:active {
        background-color: rgb(224, 224, 224);
    }
}

.searchParkinglot {
    min-height: 100vh;
    background-color: #fff;

    .searchBtn {
        width: 112px;
        height: 66px;
        line-height: 66px;
        background: #1878ea;
        border-radius: 16px;
        font-size: 28px;
        white-space: nowrap;
        color: #ffffff;
    }

    .searchParkinglot-content {
        padding: 50px 24px;

        .searchParkinglot-wrap {
            .parkinglot-name {
                font-size: 28px;
                color: #333333;
                margin-bottom: 24px;

                img {
                    width: 26px;
                    height: 26px;
                    margin-left: 35px;
                }
            }

            .searchParkinglog-list {
                .searchParkinglog-item {
                    background: #9999991a;
                    border-radius: 8px;
                    font-size: 28px;
                    padding: 20px 25px;
                    color: #212121;
                    margin-right: 16px;
                    margin-bottom: 16px;
                }
            }
        }
    }
}
</style>
<style lang="less">
.van-search__content {
    border-radius: 8px;
}
</style>
